import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { HandlebarPipe, SafeHtmlPipe } from '../../../pipes';
import { Conversation, ConversationType } from '@clientwire/api';

@Component({
  selector: 'shared-client-app-header',
  standalone: true,
  imports: [HandlebarPipe, SafeHtmlPipe],
  templateUrl: './client-app-header.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientAppHeaderComponent {
  conversationType = input<ConversationType | undefined | null>();
  conversation = input<Conversation>();
}
